"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initCoreHeader = exports.setCoreHeaderSessionAdapter = void 0;
var mono_scc_1 = require("@snoam/mono-scc");
var setCoreHeaderSessionAdapter = function (isProduction, logoutUrl, redirectUri) {
    function monetizationHasAccess(userId) {
        return __awaiter(this, void 0, void 0, function () {
            var client, productIds, access;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(window.monetization && window.monetization.hasAccess)) return [3, 2];
                        client = (0, mono_scc_1.clientShortHandNameFromHostname)(window.location.hostname);
                        productIds = (0, mono_scc_1.getProductCode)(client, isProduction);
                        return [4, window.monetization.hasAccess(productIds, userId)];
                    case 1:
                        access = _a.sent();
                        return [2, access && access.entitled];
                    case 2: return [2, false];
                }
            });
        });
    }
    function getSessionData(loginUrl, logoutUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var loginURI, logoutURI, user, hasProduct, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loginURI = loginUrl ? loginUrl : window.identity.loginUrl(JSON.stringify({ redirectUri: redirectUri ? redirectUri : window.location.href }));
                        logoutURI = logoutUrl ? logoutUrl : window.identity.logoutUrl("".concat(logoutUrl ? logoutUrl : window.location.href));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, window.identity.getUser()];
                    case 2:
                        user = _a.sent();
                        return [4, monetizationHasAccess(user.userId)];
                    case 3:
                        hasProduct = _a.sent();
                        return [2, {
                                user: user,
                                hasProduct: hasProduct,
                                loginURI: loginURI,
                                logoutURI: logoutURI,
                            }];
                    case 4:
                        e_1 = _a.sent();
                        console.error("[CBT core header] Could not get session");
                        return [2, {
                                user: null,
                                hasProduct: false,
                                loginURI: loginURI,
                                logoutURI: logoutURI
                            }];
                    case 5: return [2];
                }
            });
        });
    }
    window.__CORE_HEADER_CONFIG__ = Object.assign(window.__CORE_HEADER_CONFIG__ || {}, {
        "sessionAdapter": {
            id: 'core-header-cbt-session-adapter',
            getSessionData: getSessionData,
            onLoginClick: null,
            onLogoutClick: null,
        }
    });
};
exports.setCoreHeaderSessionAdapter = setCoreHeaderSessionAdapter;
var initCoreHeader = function (loginUrl, logoutUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!(typeof window !== "undefined")) return [3, 2];
                console.info("Init core header");
                _b = (_a = window._coreHeader).setSessionData;
                return [4, window.__CORE_HEADER_CONFIG__.sessionAdapter.getSessionData(loginUrl, logoutUrl)];
            case 1:
                _b.apply(_a, [_c.sent()]);
                return [3, 3];
            case 2:
                console.error("[CBT Core header] Missing window, init core header must be used on the client");
                _c.label = 3;
            case 3: return [2];
        }
    });
}); };
exports.initCoreHeader = initCoreHeader;
//# sourceMappingURL=core-header-session-adapter.js.map